module.exports = __webpack_public_path__ + "static/media/ms-blue-logo.e5285ae0.svg";